var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 514.70856 514.4295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.53766,705.827,513.38513,533.67438,685.07257,361.98694a50.147,50.147,0,0,0,0-70.71057l-.00012-.00006a50.14686,50.14686,0,0,0-70.71057,0L442.67444,462.96375,271.173,291.46234a50.14695,50.14695,0,0,0-70.71063,0l-.00006.00006a50.14688,50.14688,0,0,0,0,70.71057L371.96375,533.67444,199.99725,705.64093a50.14688,50.14688,0,0,0,0,70.71057l.00006.00012a50.147,50.147,0,0,0,70.71058,0L442.67444,604.38507,614.827,776.53766a50.14695,50.14695,0,0,0,70.71063,0l.00006-.00006A50.14695,50.14695,0,0,0,685.53766,705.827Z",
    transform: "translate(-185.41318 -276.69223)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIc);
export default __webpack_public_path__ + "static/media/x-ic.7f21c4ba97bbd9558dfe4c458338281f.svg";
export { ForwardRef as ReactComponent };